import { create } from 'zustand'
import type { DiscoveryResult } from '@/shared/lib/api'

interface DiscoveryResultState {
  result: DiscoveryResult | null
  repositoryPath: string
  isOpen: boolean
  
  // Actions
  showResult: (result: DiscoveryResult, repositoryPath: string) => void
  closeResult: () => void
  clearResult: () => void
}

export const useDiscoveryResultStore = create<DiscoveryResultState>((set) => ({
  result: null,
  repositoryPath: '.',
  isOpen: false,

  showResult: (result, repositoryPath) => set({
    result,
    repositoryPath,
    isOpen: true,
  }),

  closeResult: () => set({
    isOpen: false,
  }),

  clearResult: () => set({
    result: null,
    repositoryPath: '.',
    isOpen: false,
  }),
}))
